import React, { Component, ReactNode } from 'react';

import './IngestionStatistics.css';
import Spinner from '@acri-tools/react-tools/components/Spinner/Spinner';

import classNames from 'classnames';
import request from '@acri-tools/react-tools/utils/request';

import { axiosErrorHandler, toast_request_error } from '@acri-tools/react-tools/utils/global';
import parse from 'csv-parse/lib/sync';

import { format_bytes, format_number, get_data_file_url } from '../../../../utils/data';
import Chart from 'react-apexcharts';

import MediaModal from '../../../../components/MediaModal/MediaModal';
import chartsGuide from '../../../../utils/charts/charts_guide.json';

// https://apexcharts.com/react-chart-demos/line-charts/brush-chart/
// https://apexcharts.com/react-chart-demos/area-charts/github-style/

// TODO : Missing bar for cumulative

interface Props {
}
interface State {
    loading: boolean

    data?: any
}


const COLORS = {
    size:'#2e4175',
    number: '#be3232'
}

export default class IngestionStatistics extends Component<Props, State>{
    constructor(props: Props) {
        super(props);
        this.state = {
            loading: false,
        }
    }

    componentDidMount() {
        this.fetch_data()
    }


    fetch_data = async () => {
        this.setState({ loading: true });
        try {
            let res = await request(get_data_file_url(`hystorical_stats.json`), {
                // let res = await request(`${API_URL}/api/user-manager/v1/files/media/ingestion_dataset_detail_v2.csv`,{
                method: 'get'
            })

            console.debug("data", res.data);


            this.setState({ data: res.data });
        }
        catch (e) {
            axiosErrorHandler(e, { functionName: `fetch_data` });
            toast_request_error(e);
        }
        finally {
            this.setState({ loading: false })
        }
    }

    get_date_slide_chart = (title: string, data: Array<any>, size: boolean) => {
        // console.debug(`data for ${title}`, data);

        let biggest = data[0]?.value;
        let _data = data.map((d) => { 
            if(biggest < d.value){ biggest = d.value };
            return d.value
         });
        // let _dates = data.map((d) => { return d.date }).sort((d1:string, d2:string)=> {
        //     return new Date(d2).getTime() - new Date(d1).getTime();
        // });
        let _dates = data.map((d) => { return d.date }).sort((d1:string, d2:string)=> {
            return new Date(d1).getTime() - new Date(d2).getTime();
        });
        // console.debug('dates', _dates);
        let id = `${title.toLowerCase().replace(/\s/g,'')}-chart-year`;
        // let last_date = new Date(_dates[0]);
        let last_date = new Date(_dates[_dates.length - 1]);

        let min = 0;
        let max = biggest * 1.05;
        // let max = size ? 180 * Math.pow(1024, 4) : 1.8 * Math.pow(10,6);

        let color = size ? COLORS.size : COLORS.number ;

        let width = 350;
        let height = 300;

        return (
            <div className="date-slide-chart">
                <div className="chart-title"> Weekly ingested {title}
                    <MediaModal chartData={chartsGuide.bar_chart} />
                </div>
                
                <div className="date-slide-chart-chart">
                    {/* =========================
                        DATA CHART 
                        ========================= */}
                    <Chart
                        height={height}
                        width={width}
                        type="bar"
                        series={[{
                            name: title,
                            data: _data
                        }]}
                        // series={data.map((d)=>{ return d.percentage })}
                        options={{
                            grid:{
                                padding:{
                                    bottom:0
                                },
                            },
                            labels: _dates,
                            chart:{
                                animations:{ enabled: false },
                                height: height,
                                id,
                                toolbar: {
                                    show: false,
                                    autoSelected: 'pan'
                                },
                            },
                            xaxis: {
                                type: 'datetime',
                            },
                            yaxis: {
                                labels: {
                                    formatter: (value) => {
                                        return size ? `${format_bytes(value, { decimals: 0, base: 1000 })}` : `${format_number(value, 1)}`;
                                    },
                                },
                                min,
                                max
                            },
                            colors: [ color ],
                            dataLabels: {
                                enabled: false
                            },
                            fill: {
                                opacity: 1,
                                type: 'solid'
                            },
                        }}
                    />
                    {/* =========================
                        SLIDE CHART 
                        ========================= */}
                    <Chart
                        height={100}
                        width={width}
                        type="bar"
                        series={[{
                            name: title,
                            data: _data
                        }]}
                        // series={data.map((d)=>{ return d.percentage })}
                        options={{
                            labels: _dates,
                            grid:{
                                show: false,
                                padding:{
                                    top:0
                                },
                            },
                            chart:{
                                animations:{ enabled: false },
                                height: 100,
                                
                                // background: '#F6F8FA',
                                toolbar: {
                                    autoSelected: 'selection',
                                },
                                brush: {
                                    enabled: true,
                                    target: id
                                },
                                selection: {
                                    enabled: true,
                                    xaxis: {
                                        min: last_date.getTime() - 6 * 29 * 24 * 60 * 60 * 1000,
                                        max: last_date.getTime()
                                    }
                                },
                            },
                            colors: [ color ],
                            dataLabels: {
                                enabled: false
                            },
                            fill: {
                                opacity: 1,
                                type: 'solid'
                            },
                            xaxis: {
                                tickAmount: 3,
                                type: 'datetime',
                            },
                            yaxis: {
                                tickAmount: 3,
                                min,
                                max,
                                labels: {
                                    show: false
                                },
                            },
                        }}
                    />
                </div>
            </div>
        )
    }

    get_date_chart = (title: string, data: Array<any>, size: boolean, trend:string) => {
        let _data = data.map((d) => { return d.value });
        let _dates = data.map((d) => { return d.date });

        let color = size ? COLORS.size : COLORS.number ;

        let width = 500;
        let height = 300;

        return (
            <div className="date-slide-chart">
                <div className="chart-title"> Cumulative ingested {title}</div>
                <div className="date-slide-chart-chart">
                    <Chart
                        height={height}
                        width={width}
                        type="area"
                        series={[{
                            name: title,
                            data: _data
                        }]}
                        // series={data.map((d)=>{ return d.percentage })}
                        options={{
                            grid:{
                                padding:{
                                    bottom:0
                                },
                            },
                            labels: _dates,
                            chart:{
                                animations:{ enabled: false },
                                height: height,
                                toolbar: {
                                    show: false,
                                    autoSelected: 'pan'
                                },
                            },
                            xaxis: {
                                type: 'datetime',
                            },
                            yaxis: {
                                labels: {
                                    formatter: (value) => {
                                        return size ? `${format_bytes(value, { decimals: 0, base: 1000 })}` : `${format_number(value, 1)}`;
                                    },
                                },
                            },
                            colors: [ color ],
                            dataLabels: {
                                enabled: false
                            },
                            fill: {
                                opacity: 1,
                                type: 'solid'
                            },
                        }}
                    />
                </div>
                <div className="trend">
                    { trend }
                </div>
            </div>
        )
    }

    render() {
        return (
            <div className="ingestion-statistics">
                <div className="date-slide-charts">
                    {
                        this.state.loading ?
                            <div className="centered"><Spinner /></div>
                            :
                            this.state.data ?
                                <>
                                    { this.get_date_slide_chart("Products Size", this.state.data.week[0][0].values, true) }
                                    { this.get_date_slide_chart("Products Number", this.state.data.week[1][0].values, false) }
                                    { this.get_date_slide_chart("Files Number", this.state.data.week[2][0].values, false) }
                                </> 
                                :
                                <div className="no-data">No data</div>
                    }
                </div>
                <div className="date-charts">
                    {
                        this.state.loading ?
                            <div className="centered"><Spinner /></div>
                            :
                            this.state.data ?
                                <>
                                    { this.get_date_chart("Products Size", this.state.data.cum[0][0].values, true, this.state.data.trend.size.key) }
                                    { this.get_date_chart("Products Number", this.state.data.cum[1][0].values, false, this.state.data.trend.prod.key) }
                                </> 
                                :
                                <div className="no-data">No data</div>
                    }
                </div>
            </div>
        );
    }

};
